import { InputAdornment, OutlinedInput, OutlinedInputProps, } from "@mui/material";
import React from "react";
export interface BTInputFieldProps extends OutlinedInputProps {
    sx?: any;
    startAdornment?: React.ReactNode;
    endAdornment?: React.ReactNode;
}
export const BTInputField = React.forwardRef((props: BTInputFieldProps, ref: any) => {
    const { startAdornment, endAdornment, ...inputProps } = props;

    return (
        <OutlinedInput
            translate="no"
            startAdornment={startAdornment ? <InputAdornment position="start">{startAdornment}</InputAdornment> : null}
            endAdornment={endAdornment ? <InputAdornment position="end">{endAdornment}</InputAdornment> : null}
            {...inputProps}

            sx={{
                ".MuiOutlinedInput-notchedOutline": {
                    border:  '1px solid var(--color-border)',
                },
                // Ensure readable text color for disabled inputs (especially in dark mode)
                "&.Mui-disabled": {
                    color: 'var(--color-text)'
                },
                "& .MuiOutlinedInput-input.Mui-disabled": {
                    WebkitTextFillColor: 'var(--color-text)',
                    color: 'var(--color-text)',
                    opacity: 1,
                },
                "& input::placeholder": {
                    color: "#a5a5a5",
                    opacity: '1',
                    fontWeight: '400',
                },
                "&.Mui-focused": {
                    ".MuiOutlinedInput-notchedOutline": {
                        border: "1px solid var(--color-border)",
                    },
                },
                "&:hover": {
                    ".MuiOutlinedInput-notchedOutline": {
                        border: "1px solid var(--color-border)",
                    },
                },
                fontWeight: '500',
                borderRadius: '8px',
                // background: 'var(--color-surface)',
                //background: 'rgb(240, 242, 245)',
                fontSize: '14px',
                height: '36px',
                padding: '0 8px',
                margin: '0',
                // color: '#706b6b',
                color: 'var(--tasks-text-secondary)',
                outline: 'none',
                ...props.sx,
            }}
            ref={ref}
        />

    );
});
export default BTInputField;
